import { createSlice } from '@reduxjs/toolkit';

import { updateObject, createObject, deleteObject, requestObject } from './Actions';

import type { InstanceType } from '../Instances/Instances';

interface InstanceState {
  data: any;
  loading: boolean;
  error: string | null;
}

interface InstancesState {
  [key: string]: InstanceState;
}

const initialState: InstancesState = {};

// Initialize state for a specific instance
const initializeInstanceState = (instanceType: InstanceType): InstanceState => ({
  data: null,
  loading: false,
  error: null,
});

const instanceSlice = createSlice({
  name: 'instance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle requestObject
      .addCase(requestObject.pending, (state, action) => {
        const { instanceType } = action.meta.arg;
        if (!state[instanceType]) {
          state[instanceType] = initializeInstanceState(instanceType);
        }
        state[instanceType].loading = true;
        state[instanceType].error = null;
      })
      .addCase(requestObject.fulfilled, (state, action) => {
        const { instanceType, data } = action.payload;
        state[instanceType].data = data;
        state[instanceType].loading = false;
      })
      .addCase(requestObject.rejected, (state, action) => {
        const { instanceType } = action.meta.arg;
        state[instanceType].loading = false;
        state[instanceType].error = action.payload as string;
      })
      .addCase(updateObject.fulfilled, (state, action) => {
        const { instanceType, data } = action.payload;
        state[instanceType].data = data;
        state[instanceType].loading = false;
      })
      .addCase(updateObject.rejected, (state, action) => {
        const { instanceType } = action.meta.arg;
        state[instanceType].loading = false;
        state[instanceType].error = action.payload as string;
      })
      .addCase(updateObject.pending, (state, action) => {
        const { instanceType } = action.meta.arg;
        if (!state[instanceType]) {
          state[instanceType] = initializeInstanceState(instanceType);
        }
        state[instanceType].loading = true;
        state[instanceType].error = null;
      })
      .addCase(createObject.pending, (state, action) => {
        const { instanceType } = action.meta.arg;
        if (!state[instanceType]) {
          state[instanceType] = initializeInstanceState(instanceType);
        }
        state[instanceType].loading = true;
        state[instanceType].error = null;
      })
      .addCase(createObject.fulfilled, (state, action) => {
        const { instanceType, data } = action.payload;
        state[instanceType].data = data;
        state[instanceType].loading = false;
      })
      .addCase(createObject.rejected, (state, action) => {
        const { instanceType } = action.meta.arg;
        state[instanceType].loading = false;
        state[instanceType].error = action.payload as string;
      })
      .addCase(deleteObject.pending, (state, action) => {
        const { instanceType } = action.meta.arg;
        if (!state[instanceType]) {
          state[instanceType] = initializeInstanceState(instanceType);
        }
        state[instanceType].loading = true;
        state[instanceType].error = null;
      })
      .addCase(deleteObject.fulfilled, (state, action) => {
        const { instanceType, data } = action.payload;
        state[instanceType].data = data;
        state[instanceType].loading = false;
      })
      .addCase(deleteObject.rejected, (state, action) => {
        const { instanceType } = action.meta.arg;
        state[instanceType].loading = false;
        state[instanceType].error = action.payload as string;
      });
  },
});

export default instanceSlice.reducer; 